import { useCallback, useEffect, useMemo, useState } from "react";
import { getColumns, getExpandTableColumns } from "../../config";
import { useApplications } from "../../../../../context/Applications";

export const useActive = ({
  usersFetched = false,
  search = '',
  activeFilters = {},
  fetchUsers = () => { },
  perPage = 20,
  setPage = () => { },
  all = [],
  userRoles = {},
  columnConfig = {},
  setExpandedRows = () => { },
  setToggledKeys = () => { },
  loadingKeys = [],
  fetchBlocked = () => { },
  options = {},
  t = () => { },
}) => {
  const { applications } = useApplications();
  const [userTypeUser, setUserTypeUser] = useState(null);
  const [transferRightsUser, setTransferRightsUser] = useState(null);

  useEffect(() => {
    if (!usersFetched) {
      fetchUsers({ search, activeFilters });
    }
  }, [usersFetched]);

  useEffect(() => {
    if (usersFetched) {
      fetchUsers({ search, activeFilters, page: 1, perPage });
      setPage(1);
    }
  }, [search, activeFilters]);

  const _dataSource = useMemo(() => {
    return all.map((c) => ({
      ...c,
      users: [
        ...(c.users || []).filter((u) => u.status === 'active'),
        ...(c.pendingUsers || []).map((u, i) => ({ ...u, status: 'pending', id: u.invitationToken }))
      ]
        .map((u) => {
          const _role = userRoles.find((r) => r.value === u.role);

          return {
            ...u,
            isAdmin: _role?.isAdmin || u.isAdmin || c?.admin?.id === u.id,
            companyId: c.id,
            companyObject: c,
            modules: c.modules,
          };
        }),
    }));
  }, [all, userRoles]);

  const onDisableCompany = useCallback(async (v) => {
    if (typeof columnConfig.onDisable === 'function') {
      await columnConfig.onDisable(v, true);
    }

    setExpandedRows([]);
    setToggledKeys([]);
    loadingKeys.current = {};
    fetchUsers({});
    fetchBlocked({});
  }, [columnConfig, fetchUsers, fetchBlocked])

  const onDisableUsers = useCallback(async (v) => {
    if (typeof columnConfig.onDisable === 'function') {
      await columnConfig.onDisable(v);
    }

    setExpandedRows([]);
    setToggledKeys([]);
    loadingKeys.current = {};
    fetchUsers({});
    fetchBlocked({});
  }, [columnConfig, fetchUsers, fetchBlocked])

  const headerColumns = useMemo(() =>
    getColumns({ t, ...columnConfig, options, onDisable: onDisableCompany, applications })
      .filter((v) => v.show), [t, columnConfig, onDisableCompany, options, applications]);

  const expandedTableColumns = useMemo(() =>
    getExpandTableColumns({
      t, ...columnConfig, onDisable: onDisableUsers, userRoles, setTransferRightsUser, setUserTypeUser, applications,
    }).filter((v) => v.show), [t, columnConfig, onDisableUsers, userRoles, applications]);

  return {
    _dataSource,
    userTypeUser,
    headerColumns,
    transferRightsUser,
    expandedTableColumns,
    setUserTypeUser,
    setTransferRightsUser,
  }
};
